/**
 * Box definitions
 * @type {Object}
 */
const BoxDefinitions = {
  creamy: {
    id: 'creamy',
    idNum: 0,
    markers: [60, 29, 63, 30],
    synths: [],
    gridRows: 5,
    gridCols: 16,
    totalWidth: 969,        /* width from left edge of left marker to right edge of right marker */
    totalHeight: 495,       /* height from bottom edge of top marker to top edge of bottom marker */
    gridWidth: 925,
    gridHeight: 284,
    rows: [[25, 160], [25, 216], [25, 272], [25, 329], [25, 389]], /* upper left edge of each row measured from the lower left edge of the top right marker */
    squareHeight: 50,
    squareWidth: 57.75,
    sliders: [[765, 5, 50, 110, 'pitch']],
    packs: [[380, 78], [448, 78], [516, 78], [590, 78], [669, 78]], /* upper left edge of each sample pack circle measured from the lower left edge ot the top right marker */
    packHeight: 50,
    packWidth: 54,
    type: 'synth'
  },
  crunchy: {
    id: 'crunchy',
    idNum: 1,
    markers: [24, 57, 27, 58],
    synths: [],
    gridRows: 4,
    gridCols: 16,
    totalWidth: 968,
    totalHeight: 503,
    gridWidth: 925,
    gridHeight: 309,
    rows: [[24, 159], [28, 243], [28, 328], [28, 414]],
    squareHeight: 53,
    squareWidth: 58,
    masks: [[.15, .12], [.42, .12], [.70, .12]],  /* these are percentages from top, then a height also expressed as a percentage */
    sliders: [],
    packs: [[385, 75], [457, 75], [529, 75], [602, 75], [675, 75]],
    packHeight: 56,
    packWidth: 54,
    type: 'drum'
  },
  puffy: {
    id: 'puffy',
    idNum: 2,
    markers: [0, 33, 3, 34],
    synths: [],
    gridRows: 5,
    gridCols: 16,
    totalWidth: 969,        /* width from left edge of left marker to right edge of right marker */
    totalHeight: 495,       /* height from bottom edge of top marker to top edge of bottom marker */
    gridWidth: 925,
    gridHeight: 284,
    rows: [[25, 160], [25, 216], [25, 272], [25, 329], [25, 389]], /* upper left edge of each row measured from the lower left edge of the top right marker */
    squareHeight: 50,
    squareWidth: 57.75,
    sliders: [[765, 5, 50, 110, 'pitch']],
    packs: [[380, 78], [448, 78], [516, 78], [590, 78], [669, 78]], /* upper left edge of each sample pack circle measured from the lower left edge ot the top right marker */
    packHeight: 50,
    packWidth: 54,
    type: 'synth'
  }
};

export default BoxDefinitions;
